import { Stage } from './types';

export const PROD_DOMAIN = 'dohy8sp8i3s5p.cloudfront.net';
export const PUBLIC_BETA_DOMAIN = '';

export const DOMAIN_STAGE_MAPPING = {
  [Stage.DEV]: 'localhost',
  [Stage.ALPHA]: 'd39u7m3kgfxjlr',
  [Stage.BETA]: 'd1rhhgpa4iyi3x',
  [Stage.GAMMA]: 'd3tq1ghm1izy71',
  [Stage.PROD]: 'dohy8sp8i3s5p',
};
